import { TimeTrackingEntry } from '../../data/types';
import { useAppDispatch } from '../hooks';
import { addOrReplaceTimeTrackingEntryAction, deleteTimeTrackingEntryAction, setTimeTrackingEntriesAction } from '../reducers/timeTrackingReducer';

export const useTimeTrackingActions = () => {

    const dispatch = useAppDispatch();
    
    const addOrReplaceTimeTrackingEntry = (entry: TimeTrackingEntry) => {
        dispatch(addOrReplaceTimeTrackingEntryAction(entry));
    }

    const setTimeTrackingEntries = (entries: TimeTrackingEntry[]) => {
        dispatch(setTimeTrackingEntriesAction(entries));
    }

    const removeTimeTrackingEntry = (entryId: string) => {
        dispatch(deleteTimeTrackingEntryAction(entryId));
    }

    return { addOrReplaceTimeTrackingEntry, setTimeTrackingEntries, removeTimeTrackingEntry };
}
